var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconFieldNotesUpdates = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.473a.888.888 0 0 0-.89.89v11.274c0 .312-.052.612-.152.89h11.13c.493 0 .89-.396.89-.89V6.363a.888.888 0 0 0-.89-.89H9zM5.44 20.308a2.669 2.669 0 0 1-2.67-2.67V6.658c0-.493.396-.89.89-.89.493 0 .89.397.89.89v10.978c0 .494.396.89.89.89.493 0 .89-.396.89-.89V6.363A2.669 2.669 0 0 1 9 3.693h10.088a2.669 2.669 0 0 1 2.67 2.67v11.274a2.669 2.669 0 0 1-2.67 2.67H5.44zM9.297 7.549c0-.493.397-.89.89-.89h3.56c.493 0 .89.397.89.89v2.967c0 .494-.397.89-.89.89h-3.56a.888.888 0 0 1-.89-.89V7.55zm7.417-.89h1.187c.493 0 .89.397.89.89 0 .494-.397.89-.89.89h-1.187a.888.888 0 0 1-.89-.89c0-.493.397-.89.89-.89zm0 2.967h1.187c.493 0 .89.397.89.89 0 .494-.397.89-.89.89h-1.187a.888.888 0 0 1-.89-.89c0-.493.397-.89.89-.89zm-6.527 2.967H17.9c.493 0 .89.397.89.89 0 .494-.397.89-.89.89h-7.714a.888.888 0 0 1-.89-.89c0-.493.397-.89.89-.89zm0 2.967H17.9c.493 0 .89.397.89.89 0 .494-.397.89-.89.89h-7.714a.888.888 0 0 1-.89-.89c0-.493.397-.89.89-.89z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconFieldNotesUpdates, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-field-notes-updates.decf00b4.svg";
export { ForwardRef as ReactComponent };